module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700.woff2?0edb76284a7a0f8db4665b560ee2b48f";